import PropTypes from 'prop-types'
import styled from 'styled-components'

import { useTranslation } from 'react-i18next'

import colors from 'components/utils/colors'

const StyledWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  height: 32px;
  border-bottom: 1px solid ${colors.secondary90};
`

const TypeItem = styled.div`
  height: 100%;
  padding: 11px 16px 0 16px;
  box-sizing: border-box;
  cursor: pointer;
  color: ${colors.secondary60};
  border-bottom: 2px solid transparent;
  white-space: nowrap;
  font-family: Exo;
  font-size: 14px;
  user-select: none;

  &:hover {
    color: ${colors.primary35};
  }

  &.active {
    color: ${colors.primary35};
    border-bottom: 2px solid ${colors.primary35};
    cursor: default;
    font-weight: 500;
  }
`

const SubscriptionTypePanel = ({ selectSubscriptionType, selectedSubscriptionTypeId }) => {
  const { t } = useTranslation()

  const subscriptionTypes = [
    { id: 'views', name: t('subscriptionsPage.subscriptionTypeViews') },
    { id: 'tickets', name: t('subscriptionsPage.subscriptionTypeTickets') },
  ]

  return (
    <StyledWrapper>
      {subscriptionTypes.map(subscriptionType => {
        const subscriptionTypeId = subscriptionType.id
        const isSelected = selectedSubscriptionTypeId === subscriptionTypeId

        return (
          <TypeItem
            className={isSelected ? 'active' : ''}
            key={subscriptionTypeId}
            onClick={() => selectSubscriptionType(subscriptionTypeId)}
            data-test='subscription-type-item'
          >
            {subscriptionType.name}
          </TypeItem>
        )
      })}
    </StyledWrapper>
  )
}

SubscriptionTypePanel.propTypes = {
  selectSubscriptionType: PropTypes.func.isRequired,
  selectedSubscriptionTypeId: PropTypes.string.isRequired,
}

export default SubscriptionTypePanel
